import UserModel from '$models/community/UserModel';
import MinskyCollection from './MinskyCollection';
import Config from '$root/Config';

export default class UsersCollection extends MinskyCollection {
	constructor(args = {}) {
		args = Object.assign({}, args);
		args.Model = args.Model || UserModel;
		args.identifier = args.identifier || 'uuid';
		args.config = Object.assign(
			{
				url: Config.getUrl('acUsers'),
				params: {
					format: 'simple',
					limit: 50,
				},
			},
			args.config,
		);

		super(args);
	}

	fetch(preventClear) {
		this.setConfig('url', Config.getUrl('acUsers'));
		this.setConfig('params', {
			format: 'simple',
			limit: 50,
		});

		// loadNext passes preventClear=true for a single page only
		if (preventClear) {
			return super.fetch(true);
		}

		this.resetPageParams();

		return new Promise((resolve, reject) => {
			super
				.fetch(false)
				.then(() => {
					const loadRemaining = () => {
						if (!this.hasNextPage()) {
							resolve(this);
							return;
						}

						this.loadNext()
							.then(loadRemaining)
							.catch(reject);
					};

					loadRemaining();
				})
				.catch(reject);
		});
	}
}
